/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_Pending_IndicatorInputs */



/**
* | output |
* | --- |
* | "Unsaved change" |
*
* @param {Sub_Quotas_Pending_IndicatorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_pending_indicator = /** @type {((inputs?: Sub_Quotas_Pending_IndicatorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Pending_IndicatorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht gespeicherte Änderung")
	return /** @type {LocalizedString} */ ("Unsaved change")
});